import { render } from "./FreeTrial.vue?vue&type=template&id=0cf12e19"
import script from "./FreeTrial.vue?vue&type=script&lang=js"
export * from "./FreeTrial.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__